import { CREATE_USER, GET_USERS, SET_USERS } from './actionTypes'

export function createUserSaga(data) {
  return {
    type: CREATE_USER,
    data,
  }
}

export function setUsers(data) {
  return {
    type: SET_USERS,
    data,
  }
}

export function getUsersSaga(data) {
  return {
    type: GET_USERS,
    data,
  }
}
